import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useTimeline } from "examples/Timeline/context";
import timelineItem from "examples/Timeline/TimelineItem/styles";
import moment from "moment";

function TimelineItem({
  color,
  icon,
  title,
  dateTime,
  description,
  lastItem,
  startDate,
  endDate,
  startTime,
  endTime,
}) {
  const isDark = useTimeline();

  return (
    <MDBox position="relative" mb="-3px" sx={(theme) => timelineItem(theme, { lastItem, isDark })}>
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgColor={color}
        color="white"
        width="2rem"
        height="2rem"
        borderRadius="50%"
        position="absolute"
        top="8%"
        left="2px"
        zIndex={2}
        sx={{ fontSize: ({ typography: { size } }) => size.sm }}
      >
        <Icon fontSize="inherit">{icon}</Icon>
      </MDBox>
      <MDBox ml={5.75} pt={description ? 0.7 : 0.5} lineHeight={0} maxWidth="30rem">
        <MDTypography
          variant="button"
          fontWeight="medium"
          color={isDark ? "white" : "dark"}
          fontSize="16px"
        >
          {title}
        </MDTypography>
        <MDBox mt={2}>
          <MDBox mb={1}>
            <MDTypography
              variant="caption"
              sx={{
                fontSize: "13px",
                fontWeight: 400,
                marginRight: "6px",
              }}
            >
              Date:
            </MDTypography>
            <MDTypography
              variant="caption"
              sx={{
                fontSize: "13px",
                fontWeight: 400,
              }}
            >
              {moment(startDate).format("DD MMM YYYY")}
              {endDate &&
                endDate !== startDate &&
                ` - ${moment(`${endDate}`).format("DD MMM YYYY")}`}
            </MDTypography>
          </MDBox>
          <MDBox>
            <MDTypography
              variant="caption"
              sx={{
                fontSize: "13px",
                fontWeight: 400,
                marginRight: "6px",
              }}
            >
              Time:
            </MDTypography>
            <MDTypography
              variant="caption"
              sx={{
                fontSize: "13px",
                fontWeight: 400,
              }}
            >
              {moment(`${startTime}`, ["HH:mm"]).format("hh:mm A")}
              {endTime && ` - ${moment(`${endTime}`, ["HH:mm"]).format("hh:mm A")}`}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of TimelineItem
TimelineItem.defaultProps = {
  color: "info",
  lastItem: false,
  description: "",
};

// Typechecking props for the TimelineItem
TimelineItem.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  dateTime: PropTypes.string.isRequired,
  description: PropTypes.string,
  lastItem: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
};

export default TimelineItem;
